export default __webpack_public_path__ + "static/media/correo-electronico.ea748274.svg";